// Product app origins — used for SSO launches from the hub.
export const PRODUCT_SSO_DOMAINS: Record<'vetaxis' | 'staffaxis' | 'noteaxis', string> = {
  vetaxis: 'https://vetaxis.bioaxis.co.za',
  staffaxis: 'https://app.staff.bioaxis.co.za',
  noteaxis: 'https://noteaxis.bioaxis.co.za',
};

export type LaunchableProductId = keyof typeof PRODUCT_SSO_DOMAINS;

export const isLaunchableProduct = (value: string | null): value is LaunchableProductId =>
  !!value && value in PRODUCT_SSO_DOMAINS;

export const productSsoUrl = (productId: LaunchableProductId, token: string) =>
  `${PRODUCT_SSO_DOMAINS[productId]}/auth/sso?token=${encodeURIComponent(token)}`;
